import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { PlaneTakeoff } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApi, errMsg } from "@/lib/api";
import { money } from "@/lib/format";

export default function StartTracking({ trip, staff }) {
  const api = useApi();
  const navigate = useNavigate();
  const [optionId, setOptionId] = useState(trip.booked_option_id || trip.client_selection?.option_id || "");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (trip.booked_option_id) setOptionId(trip.booked_option_id);
  }, [trip.booked_option_id]);
  if (trip.tracking_id) {
    return <Link to={`/tracking/${trip.tracking_id}`} className="frame-btn gold" data-testid="open-tracking-link"><PlaneTakeoff size={13} /> Flight tracking</Link>;
  }
  if (!staff || !["confirmed", "itinerary_sent"].includes(trip.status)) return null;
  const start = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/trips/${trip.id}/tracking`, { option_id: optionId || null });
      toast.success("Tracking started");
      navigate(`/tracking/${data.id}`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="start-tracking">
      {!trip.booked_option_id && !trip.client_selection?.option_id && (
        <Select value={optionId} onValueChange={setOptionId}>
          <SelectTrigger className="w-64 bg-[#0d0f14] border-white/10" data-testid="start-tracking-option-select"><SelectValue placeholder="Pick the confirmed option" /></SelectTrigger>
          <SelectContent>{trip.options.map((o) => <SelectItem key={o.id} value={o.id}>{o.aircraft_type}{o.tail_number ? ` · ${o.tail_number}` : ""} · {money(o.price, o.currency)}</SelectItem>)}</SelectContent>
        </Select>
      )}
      <button type="button" className="frame-btn gold" onClick={start} disabled={busy || !optionId} data-testid="start-tracking-btn">
        <PlaneTakeoff size={13} /> {busy ? "Starting…" : "Start tracking"}
      </button>
    </div>
  );
}
